/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */
import * as React from "react";
import { CodeDryer } from "./src/CodeDryer";
import "./src/styles/code-dryer.css";

export const wrapPageElement = ({ element, props }) => {
  if (process.env.NODE_ENV === "development") {
    return (
      <>
        <CodeDryer />
        {element}
      </>
    );
  }

  return element;
};
